module.exports = __webpack_public_path__ + "img/keyboard.9dba7e48.png";